import React from 'react';
import CONDITIONS from '../assets/conditions';
import '../styles/conditions.css';

const ConditionBadges = ({ conditions = [], editable = false, onToggle }) => {
  if (!editable && conditions.length === 0) return null;

  return (
    <div className={`conditionBadges${editable ? ' editable' : ''}`}>
      {editable
        ? CONDITIONS.map(c => {
            const active = conditions.includes(c.key);
            return (
              <button
                key={c.key}
                className={`conditionBtn${active ? ' active' : ''}`}
                title={c.label}
                onClick={() => onToggle(c.key)}
                type="button"
              >
                {c.emoji}
              </button>
            );
          })
        : conditions.map(key => {
            const c = CONDITIONS.find(c => c.key === key);
            if (!c) return null;
            return (
              <span key={key} className='conditionDisplay' title={c.label}>
                {c.emoji}
              </span>
            );
          })
      }
    </div>
  );
};

export default ConditionBadges;
